/**
 * Custom Facets Handler
 * Maneja el comportamiento de los filtros con checkboxes y botón de aplicar
 */

class CustomFacetsHandler {
  constructor() {
    this.form = null;
    this.checkboxes = [];
    this.applyButton = null;
    
    this.init();
  }

  init() {
    // Esperar a que el DOM esté completamente cargado
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    if (this.listenersBound) return;
    this.listenersBound = true;

    // El tema clona el formulario al abrir el panel móvil.
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('#FacetFiltersForm[data-filter-form]');
      if (!form) return;
      e.preventDefault();
      this.useForm(form);
      this.applyFilters();
    });

    document.addEventListener('click', (e) => {
      const button = e.target.closest('[data-filter-clear]');
      const form = button?.closest('#FacetFiltersForm[data-filter-form]');
      if (!form) return;
      e.preventDefault();
      this.useForm(form);
      this.clearAllFilters();
    });

    document.addEventListener('change', (e) => {
      const checkbox = e.target.closest('input[data-filter-checkbox]');
      if (!checkbox?.closest('#FacetFiltersForm[data-filter-form]')) return;
      this.updateCheckboxState(checkbox);
    });
  }

  useForm(form) {
    this.form = form;
    this.checkboxes = form.querySelectorAll('input[data-filter-checkbox]');
    this.applyButton = form.querySelector('[data-filter-apply]');
  }

  updateCheckboxState(checkbox) {
    const listItem = checkbox.closest('li');
    if (checkbox.checked) {
      listItem?.classList.add('is--selected');
    } else {
      listItem?.classList.remove('is--selected');
    }
  }

  applyFilters() {
    console.log('Custom Facets: Applying filters...');
    
    // Mostrar loading state
    this.showLoading();
    
    // Construir URL con filtros seleccionados
    const url = this.buildFilterURL();
    
    // Navegar a la URL con filtros
    window.location.href = url;
  }

  buildFilterURL() {
    const formData = new FormData(this.form);
    const params = new URLSearchParams(window.location.search);
    
    // Limpiar parámetros de filtros existentes
    for (const key of [...params.keys()]) {
      if (key.startsWith('filter.') || key === 'page') {
        params.delete(key);
      }
    }
    
    // Agregar nuevos filtros seleccionados
    // Para manejar múltiples valores del mismo filtro correctamente, 
    // necesitamos agregar cada uno como un parámetro separado
    for (const [name, value] of formData.entries()) {
      if (name !== 'q' && name !== 'type' && value) {
        // En lugar de concatenar con comas, usar append para crear múltiples parámetros
        if (name.startsWith('filter.')) {
          params.append(name, value);
        } else {
          params.set(name, value);
        }
      }
    }
    
    // Construir URL final
    const baseURL = window.location.pathname;
    const queryString = params.toString();
    
    return queryString ? `${baseURL}?${queryString}` : baseURL;
  }

  clearAllFilters() {
    console.log('Custom Facets: Clearing all filters...');
    
    // Desmarcar todos los checkboxes
    this.checkboxes.forEach(checkbox => {
      checkbox.checked = false;
      this.updateCheckboxState(checkbox);
    });
    
    // Resetear sliders de precio si existen
    this.resetPriceSliders();
    
    // Navegar a la URL base sin filtros
    const baseURL = window.location.pathname;
    const params = new URLSearchParams(window.location.search);
    
    // Mantener solo parámetros que no sean filtros
    for (const key of [...params.keys()]) {
      if (key.startsWith('filter.') || key === 'page') {
        params.delete(key);
      }
    }
    
    const queryString = params.toString();
    const finalURL = queryString ? `${baseURL}?${queryString}` : baseURL;
    
    window.location.href = finalURL;
  }

  resetPriceSliders() {
    // Resetear sliders de precio si existe noUiSlider
    const priceSliders = this.form.querySelectorAll('.t4s-price_steps_slider');
    priceSliders.forEach(slider => {
      if (slider.noUiSlider) {
        const minInput = this.form.querySelector('.t4s-min_price');
        const maxInput = this.form.querySelector('.t4s-max_price');
        if (minInput && maxInput) {
          const min = parseFloat(minInput.dataset.min) || 0;
          const max = parseFloat(maxInput.dataset.max) || 1000;
          slider.noUiSlider.set([min, max]);
        }
      }
    });
  }

  showLoading() {
    if (this.applyButton) {
      this.applyButton.textContent = 'Aplicando...';
      this.applyButton.disabled = true;
    }
  }

  // Método para reinicializar después de AJAX
  reinitialize() {
    console.log('Custom Facets: Reinitializing...');
    this.setupEventListeners();
  }
}

// Inicializar el handler
let customFacetsHandler;

// Función global para reinicializar (útil para cuando se actualize el contenido via AJAX)
window.reinitializeCustomFacets = function() {
  if (customFacetsHandler) {
    customFacetsHandler.reinitialize();
  } else {
    customFacetsHandler = new CustomFacetsHandler();
  }
};

// Inicializar cuando el script se carga
customFacetsHandler = new CustomFacetsHandler();
